export interface CombinedSearchGroup {
  name: string;
  criteria: Record<string, string>;
}

export function combinedSearchGroups(value: string): CombinedSearchGroup[] {
  try {
    const groups: unknown = JSON.parse(value);
    if (!Array.isArray(groups) || !groups.length) return [];
    if (!groups.every((group) => (
      group && typeof group === 'object'
      && typeof group.name === 'string'
      && group.criteria && typeof group.criteria === 'object'
      && !Array.isArray(group.criteria)
      && !('any_of' in group.criteria)
      && Object.values(group.criteria).every((filter) => typeof filter === 'string')
    ))) return [];
    return groups as CombinedSearchGroup[];
  } catch {
    return [];
  }
}
